import { useState, useEffect } from "react";
import { X } from "lucide-react";

export const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowTooltip(true), 3000);
    const hideTimer = setTimeout(() => setShowTooltip(false), 8000);
    return () => { clearTimeout(timer); clearTimeout(hideTimer); };
  }, []);

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/50670473873?text=${encodeURIComponent("Hola! Quiero agendar una llamada.")}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[9999] flex items-end gap-3">
      <div className={`relative bg-card border border-border rounded-2xl shadow-xl p-4 max-w-[200px] transition-all duration-500 ease-out ${showTooltip || isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'}`}>
        <p className="text-sm text-foreground font-medium leading-snug">💬 ¿Necesitás ayuda? ¡Escribinos!</p>
        <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-full">
          <div className="w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-card"></div>
        </div>
      </div>

      <div className="relative">
        <div className="absolute inset-0 bg-primary rounded-full animate-ping opacity-25 pointer-events-none"></div>
        <button
          onClick={handleWhatsAppClick}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          className={`relative flex items-center justify-center bg-primary hover:bg-accent text-primary-foreground rounded-full shadow-2xl transition-all duration-300 ease-out hover:scale-110 hover:shadow-[0_8px_30px_hsl(var(--accent)/0.5)] active:scale-95 ${isHovered ? 'px-5 py-4' : 'p-4'} group z-10`}
          aria-label="Contactar por WhatsApp"
        >
          <svg viewBox="0 0 24 24" fill="currentColor" className={`h-7 w-7 transition-transform duration-300 ${isHovered ? 'scale-110' : ''}`}>
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
          </svg>
          <span className={`font-semibold text-sm whitespace-nowrap overflow-hidden transition-all duration-300 ease-out ${isHovered ? 'max-w-[100px] opacity-100 ml-2' : 'max-w-0 opacity-0 ml-0'}`}>
            WhatsApp
          </span>
        </button>
        <button
          onClick={(e) => { e.stopPropagation(); setIsVisible(false); }}
          aria-label="Cerrar"
          className="absolute -top-1 -right-1 bg-background/90 backdrop-blur-sm border border-border hover:bg-accent hover:text-accent-foreground hover:border-accent text-muted-foreground rounded-full h-6 w-6 flex items-center justify-center transition-all duration-200 z-20 shadow-md hover:shadow-lg hover:scale-110"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
};
